import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/base.css';
import DashboardApp from './DashboardApp';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <DashboardApp />
  </React.StrictMode>
);
